var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0234 2.95626C3.23168 2.74798 3.56936 2.74798 3.77764 2.95626L9.11098 8.28959C9.31926 8.49787 9.31926 8.83556 9.11098 9.04384C8.9027 9.25212 8.56501 9.25212 8.35673 9.04384L3.0234 3.71051C2.81512 3.50223 2.81512 3.16454 3.0234 2.95626Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04457 3.02071C9.25285 3.22899 9.25285 3.56668 9.04457 3.77496L3.71124 9.10829C3.50296 9.31657 3.16527 9.31657 2.95699 9.10829C2.74871 8.90001 2.74871 8.56232 2.95699 8.35404L8.29032 3.02071C8.4986 2.81243 8.83629 2.81243 9.04457 3.02071Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.77436ac6.svg";
export { ForwardRef as ReactComponent };